import { trackEvent } from "./track"
import type { AnalyticsEventName } from "./types"

/**
 * Bridge for the advisors/live-chat code ported from lpr-web, which calls
 * `trackAppyCntEvent(name, _legacyArg, data)`. Maps onto the project's
 * `trackEvent`, stashing the structured payload under `metadata`.
 */
export function useLogger() {
  const trackAppyCntEvent = (
    eventName: AnalyticsEventName,
    _legacy: unknown,
    data?: Record<string, unknown>,
  ) => {
    trackEvent(eventName, { metadata: data })
  }

  return { trackAppyCntEvent }
}
